import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-69d13806"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "text-center mb-5" }, "Bạn có chắc muốn xoá dữ liệu này?", -1))
const _hoisted_2 = { class: "text-center mb-5" }
const _hoisted_3 = { class: "mb-6" }
const _hoisted_4 = { class: "detail-info-row" }
const _hoisted_5 = { class: "detail-info-pair" }
const _hoisted_6 = { class: "detail-info-pair__label" }
const _hoisted_7 = { class: "detail-info-pair__value" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "detail-info-pair" }
const _hoisted_10 = { class: "detail-info-pair__label" }
const _hoisted_11 = { class: "detail-info-pair__value" }
const _hoisted_12 = { class: "detail-info-pair" }
const _hoisted_13 = { class: "detail-info-pair__label" }
const _hoisted_14 = { class: "detail-info-pair__value" }
const _hoisted_15 = {
  key: 0,
  class: "detail-info-pair"
}
const _hoisted_16 = { class: "detail-info-pair__label" }
const _hoisted_17 = { class: "detail-info-pair__value" }
const _hoisted_18 = { class: "detail-info-row" }
const _hoisted_19 = { class: "detail-info-pair" }
const _hoisted_20 = { class: "detail-info-pair__label" }
const _hoisted_21 = { class: "detail-info-pair__value" }
const _hoisted_22 = { class: "detail-info-pair" }
const _hoisted_23 = { class: "detail-info-pair__label" }
const _hoisted_24 = { class: "detail-info-pair__value" }
const _hoisted_25 = { class: "detail-info-row" }
const _hoisted_26 = { class: "detail-info-pair" }
const _hoisted_27 = { class: "detail-info-pair__label" }
const _hoisted_28 = { class: "detail-info-pair__value" }
const _hoisted_29 = { class: "detail-info-pair" }
const _hoisted_30 = { class: "detail-info-pair__label" }
const _hoisted_31 = { class: "detail-info-pair__value" }
const _hoisted_32 = { class: "detail-info-pair" }
const _hoisted_33 = { class: "detail-info-pair__label" }
const _hoisted_34 = { class: "detail-info-pair__value" }
const _hoisted_35 = {
  key: 0,
  class: "detail-info-pair"
}
const _hoisted_36 = { class: "detail-info-pair__label" }
const _hoisted_37 = { class: "detail-info-pair__value" }
const _hoisted_38 = { class: "detail-info-row" }
const _hoisted_39 = { class: "detail-info-pair" }
const _hoisted_40 = { class: "detail-info-pair__label" }
const _hoisted_41 = { class: "detail-info-pair__value" }
const _hoisted_42 = { class: "detail-info-pair" }
const _hoisted_43 = { class: "detail-info-pair__label" }
const _hoisted_44 = { class: "detail-info-pair__value" }
const _hoisted_45 = {
  key: 0,
  class: "d-flex flex-column align-items-start w-100"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseLoading = _resolveComponent("BaseLoading")!
  const _component_ConfirmHoanThanh = _resolveComponent("ConfirmHoanThanh")!
  const _component_ConfirmationDialog = _resolveComponent("ConfirmationDialog")!
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_PageHeaderActionItem = _resolveComponent("PageHeaderActionItem")!
  const _component_Can = _resolveComponent("Can")!
  const _component_PageHeaderApprovals = _resolveComponent("PageHeaderApprovals")!
  const _component_PageHeaderActions = _resolveComponent("PageHeaderActions")!
  const _component_DetailTopicLottie = _resolveComponent("DetailTopicLottie")!
  const _component_LabelCustom = _resolveComponent("LabelCustom")!
  const _component_BaseLink = _resolveComponent("BaseLink")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_TaiKhoanSelectionV2 = _resolveComponent("TaiKhoanSelectionV2")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_PageContentSection = _resolveComponent("PageContentSection")!
  const _component_PhieuXuatKhoVatTuTable = _resolveComponent("PhieuXuatKhoVatTuTable")!
  const _component_PageContentBase = _resolveComponent("PageContentBase")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isLoadingData || _ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_BaseLoading, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmHoanThanh, {
      for: 'phieu_xuat',
      "phieu-xuat-data": _ctx.approvingPhieuXuat,
      show: !!_ctx.approvingPhieuXuat,
      onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.approvingPhieuXuat = null)),
      onConfirm: _ctx.confirmApproval
    }, null, 8, ["phieu-xuat-data", "show", "onConfirm"]),
    _createVNode(_component_ConfirmationDialog, {
      title: `Phiếu xuất số ${_ctx.phieuXuatDetail.so_phieu}`,
      "is-display": _ctx.showConfirmDeleteModal,
      width: "20%",
      onOnCloseButtonClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showConfirmDeleteModal = false)),
      onOnCloseIconClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showConfirmDeleteModal = false)),
      onOnConfirmButtonClick: _ctx.confirmDelete
    }, {
      default: _withCtx(() => [
        _hoisted_1
      ]),
      _: 1
    }, 8, ["title", "is-display", "onOnConfirmButtonClick"]),
    _createVNode(_component_ConfirmationDialog, {
      title: `Phiếu xuất số ${_ctx.phieuXuatDetail.so_phieu}`,
      "is-display": _ctx.confirmingApproval,
      width: "20%",
      onOnCloseButtonClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.confirmingApproval = false)),
      onOnCloseIconClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.confirmingApproval = false)),
      onOnConfirmButtonClick: _ctx.onConfirmApprovalDialog
    }, {
      default: _withCtx(() => [
        _createElementVNode("h5", _hoisted_2, [
          _createTextVNode(" Bạn có chắc chắn muốn phê duyệt phiếu xuất kho có số phiếu "),
          _createElementVNode("strong", null, _toDisplayString(_ctx.phieuXuatDetail.so_phieu), 1),
          _createTextVNode("? ")
        ])
      ]),
      _: 1
    }, 8, ["title", "is-display", "onOnConfirmButtonClick"]),
    (_ctx.hasApprovalActions)
      ? (_openBlock(), _createBlock(_component_PageHeaderApprovals, { key: 1 }, {
          default: _withCtx(() => [
            (
        _ctx.phieuXuatDetail?.processing_status &&
        _ctx.getDuyetPhieuNhapXuatStatus(_ctx.phieuXuatDetail.processing_status)
          .isDisplay &&
        _ctx.canDuyetPxk
      )
              ? (_openBlock(), _createBlock(_component_PageHeaderActionItem, {
                  key: 0,
                  variant: "warning",
                  disabled: 
        _ctx.getDuyetPhieuNhapXuatStatus(_ctx.phieuXuatDetail.processing_status)
          .isDisabled
      ,
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.confirmingApproval = true))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: _ctx.faCheckDouble }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Xác nhận phiếu xuất kho ")
                  ]),
                  _: 1
                }, 8, ["disabled"]))
              : _createCommentVNode("", true),
            (_ctx.phieuXuatDetail?.processing_status)
              ? (_openBlock(), _createBlock(_component_Can, {
                  key: 1,
                  all: [_ctx.PHIEU_XUAT_KHO.DUYET]
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_PageHeaderActionItem, {
                      variant: "success",
                      disabled: 
          _ctx.getDuyetPhieuNhapXuatStatus(_ctx.phieuXuatDetail.processing_status)
            .isDisabled
        ,
                      onClick: _ctx.handleAdminSign
                    }, {
                      icon: _withCtx(() => [
                        _createVNode(_component_font_awesome_icon, { icon: _ctx.faCheckToSlot }, null, 8, ["icon"])
                      ]),
                      default: _withCtx(() => [
                        _createTextVNode(" Duyệt phiếu xuất kho ")
                      ]),
                      _: 1
                    }, 8, ["disabled", "onClick"])
                  ]),
                  _: 1
                }, 8, ["all"]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_PageHeaderActions, null, {
      default: _withCtx(() => [
        (!_ctx.phieuXuatDetail?.is_approved)
          ? (_openBlock(), _createBlock(_component_Can, {
              key: 0,
              all: [_ctx.PHIEU_XUAT_KHO.XOA]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PageHeaderActionItem, {
                  variant: "danger",
                  onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showConfirmDeleteModal = true))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: _ctx.faTrash }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Xoá phiếu xuất kho ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["all"]))
          : _createCommentVNode("", true),
        (_ctx.editable)
          ? (_openBlock(), _createBlock(_component_PageHeaderActionItem, {
              key: 1,
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToEditPhieuXuatLink(_ctx.phieuXuatDetail)))
            }, {
              icon: _withCtx(() => [
                _createVNode(_component_font_awesome_icon, { icon: _ctx.faPencil }, null, 8, ["icon"])
              ]),
              default: _withCtx(() => [
                _createTextVNode(" Chỉnh sửa phiếu xuất kho ")
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        (!_ctx.editable && _ctx.editableTaiKhoan)
          ? (_openBlock(), _createBlock(_component_Can, {
              key: 2,
              all: [_ctx.PHIEU_XUAT_KHO.SUA]
            }, {
              default: _withCtx(() => [
                _createVNode(_component_PageHeaderActionItem, {
                  variant: "warning",
                  onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToEditPhieuXuatLink(_ctx.phieuXuatDetail)))
                }, {
                  icon: _withCtx(() => [
                    _createVNode(_component_font_awesome_icon, { icon: _ctx.faPencil }, null, 8, ["icon"])
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(" Sửa T/k nợ ")
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["all"]))
          : _createCommentVNode("", true),
        _createVNode(_component_PageHeaderActionItem, { onClick: _ctx.openPhieuXuatKhoPdfViewer }, {
          icon: _withCtx(() => [
            _createVNode(_component_font_awesome_icon, { icon: _ctx.faPrint }, null, 8, ["icon"])
          ]),
          default: _withCtx(() => [
            _createTextVNode(" In phiếu xuất kho ")
          ]),
          _: 1
        }, 8, ["onClick"])
      ]),
      _: 1
    }),
    _createVNode(_component_PageContentBase, { plain: "" }, {
      default: _withCtx(() => [
        _createVNode(_component_PageContentSection, { "always-expanded": true }, {
          header: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.titleComputed), 1)
          ]),
          illustration: _withCtx(() => [
            _createVNode(_component_DetailTopicLottie, { topic: "phieu-xuat" })
          ]),
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              model: _ctx.form,
              class: "bootstrap-form"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Kho ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_7, [
                        (_ctx.phieuXuatDetail.kho)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                              _createVNode(_component_BaseLink, {
                                to: {
                      name: 'chi-tiet-kho',
                      params: {
                        id: _ctx.phieuXuatDetail.kho.id || '',
                      },
                    }
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(_ctx.phieuXuatDetail.kho.ten_kho || ""), 1)
                                ]),
                                _: 1
                              }, 8, ["to"])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_9, [
                      _createElementVNode("div", _hoisted_10, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Số phiếu ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.form.so_phieu), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["detail-info-row", {
              'detail-info-row--single': !(
                _ctx.phieuXuatDetail && _ctx.isCreatingFormBierBan
              ),
            }])
                  }, [
                    _createElementVNode("div", _hoisted_12, [
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode(" Người nhận ")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.phieuXuatDetail?.ten_nguoi_nhan || ""), 1)
                    ]),
                    (_ctx.phieuXuatDetail && _ctx.isCreatingFormBierBan)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                          _createElementVNode("div", _hoisted_16, [
                            _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                              default: _withCtx(() => [
                                _createTextVNode("BBGT")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_17, [
                            _createVNode(_component_BaseLink, {
                              to: {
                    name: 'chi-tiet-bien-ban-giai-the',
                    params: {
                      id: _ctx.phieuXuatDetail.bien_ban_giai_the?.id ?? _ctx.idBienBan,
                    },
                  }
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.phieuXuatDetail.bien_ban_giai_the?.so_bien_ban ??
                    _ctx.bienBanGiaiTheDetail?.so_bien_ban), 1)
                              ]),
                              _: 1
                            }, 8, ["to"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", _hoisted_18, [
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode("Lý do")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.form.receiptReason), 1)
                    ]),
                    _createElementVNode("div", _hoisted_22, [
                      _createElementVNode("div", _hoisted_23, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode("Số biên bản")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.form.so_bien_ban), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_25, [
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode("Ngày tạo")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.formatDisplayingDate(new Date(_ctx.phieuXuatDetail.created_at))), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      _createElementVNode("div", _hoisted_30, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode("Cập nhật cuối")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.formatDisplayingDate(new Date(_ctx.phieuXuatDetail.updated_at))), 1)
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: _normalizeClass(["detail-info-row", {
              'detail-info-row--single': !_ctx.phieuXuatDetail.processing_status,
            }])
                  }, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode("Trạng thái duyệt")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_el_tag, {
                          class: "inline-flex items-center min-w-min rounded-none",
                          type: _ctx.phieuXuatDetail.is_approved ? 'success' : 'danger',
                          effect: _ctx.phieuXuatDetail.is_approved ? 'light' : 'dark'
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.phieuXuatDetail.is_approved ? "Đã duyệt" : "Chưa duyệt"), 1)
                          ]),
                          _: 1
                        }, 8, ["type", "effect"])
                      ])
                    ]),
                    (!!_ctx.phieuXuatDetail.processing_status)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                          _createElementVNode("div", _hoisted_36, [
                            _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                              default: _withCtx(() => [
                                _createTextVNode("Trạng thái")
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_37, [
                            _createVNode(_component_el_button, {
                              size: "mini",
                              type: 
                    _ctx.mapPhieuNhapXuatStatusToLevelColor(
                      _ctx.phieuXuatDetail.processing_status
                    )
                  
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.phieuXuatDetail.processing_status
                      ? _ctx.mapPhieuNhapXuatStatusToLabel(
                          _ctx.phieuXuatDetail.processing_status
                        )
                      : ""), 1)
                              ]),
                              _: 1
                            }, 8, ["type"])
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ], 2),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _createElementVNode("div", _hoisted_40, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode("Loại định mức")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.phieuXuatDetail.loai_dinh_muc === 1
                    ? "Trong định mức"
                    : _ctx.phieuXuatDetail.loai_dinh_muc === 2
                    ? "Ngoài định mức"
                    : "-"), 1)
                    ]),
                    _createElementVNode("div", _hoisted_42, [
                      _createElementVNode("div", _hoisted_43, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode("Loại phiếu")
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.mapLoaiPhieuXuatToLabel(_ctx.phieuXuatDetail.loai_phieu)), 1)
                    ])
                  ]),
                  (_ctx.phieuXuatDetail.tk_no)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                        _createVNode(_component_LabelCustom, { "is-text-muted": true }, {
                          default: _withCtx(() => [
                            _createTextVNode("Tài khoản nợ")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_TaiKhoanSelectionV2, {
                          class: "w-100",
                          "ma-tai-khoan-prop": 
                _ctx.phieuXuatDetail.tk_no.ma_tk
                  ? parseInt(_ctx.phieuXuatDetail.tk_no.ma_tk)
                  : undefined
              ,
                          "ma-chi-tiet-prop": 
                _ctx.phieuXuatDetail.tk_no.ma_ct
                  ? _ctx.phieuXuatDetail.tk_no.ma_ct
                  : undefined
              ,
                          "ten-tai-khoan-prop": _ctx.phieuXuatDetail.tk_no.ten_tk,
                          "read-only": true
                        }, null, 8, ["ma-tai-khoan-prop", "ma-chi-tiet-prop", "ten-tai-khoan-prop"])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _: 1
            }, 8, ["model"])
          ]),
          _: 1
        }),
        _createVNode(_component_PageContentSection, { "always-expanded": true }, {
          header: _withCtx(() => [
            _createTextVNode("Danh sách vật tư xuất kho")
          ]),
          default: _withCtx(() => [
            _createVNode(_component_PhieuXuatKhoVatTuTable, {
              groups: _ctx.selectedKhoItems,
              "is-loading": _ctx.isLoading && _ctx.isLoadingData,
              mode: "readonly",
              "loai-phieu": _ctx.phieuXuatDetail.loai_phieu,
              "show-ly-do-column": _ctx.phieuXuatDetail.loai_phieu === 2,
              "show-thu-hoi-columns": true
            }, null, 8, ["groups", "is-loading", "loai-phieu", "show-ly-do-column"])
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}